import React from "react";
import { Button, Tooltip } from "@mui/material";
import SportsSoccerOutlinedIcon from "@mui/icons-material/SportsSoccerOutlined";
import AutoAwesomeOutlinedIcon from "@mui/icons-material/AutoAwesomeOutlined";
import {
  getSectionSwitchAriaLabel,
  getSectionSwitchLabel,
  getSectionSwitchTooltip,
} from "../../../utils/homeFlow";

export default function SectionSwitchButton({
  isPageantSection,
  onClick,
  fullWidth = false,
  size = "medium",
}) {
  const label = getSectionSwitchLabel(isPageantSection);
  const Icon = isPageantSection ? SportsSoccerOutlinedIcon : AutoAwesomeOutlinedIcon;

  const button = (
    <Button
      onClick={onClick}
      aria-label={getSectionSwitchAriaLabel(isPageantSection)}
      startIcon={<Icon sx={{ fontSize: size === "small" ? 18 : 20 }} />}
      fullWidth={fullWidth}
      sx={{
        textTransform: "none",
        fontWeight: 700,
        fontSize: size === "small" ? 12 : { xs: 12, sm: 13 },
        lineHeight: 1.2,
        color: "#ef364e",
        border: "2px solid #ef364e",
        borderRadius: "999px",
        px: fullWidth ? 2 : { xs: 1.25, sm: 1.75 },
        py: size === "small" ? 0.35 : 0.5,
        minWidth: fullWidth ? "100%" : 0,
        whiteSpace: "nowrap",
        flexShrink: 0,
        bgcolor: "#fff",
        justifyContent: fullWidth ? "flex-start" : "center",
        "&:hover": {
          bgcolor: "rgba(239,54,78,0.08)",
          borderColor: "#d93349",
        },
      }}
    >
      {label}
    </Button>
  );

  if (fullWidth) {
    return button;
  }

  return (
    <Tooltip
      title={getSectionSwitchTooltip(isPageantSection)}
      arrow
      placement="bottom"
    >
      {button}
    </Tooltip>
  );
}
